/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FeatureFlagContext {
    getFixupPrototypeFunction() { return FeatureFlagContext.fixupPrototype; }

    static newInstance(model: Partial<FeatureFlagContext>): FeatureFlagContext {
        let obj = Object.assign(new FeatureFlagContext(), model);
        FeatureFlagContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FeatureFlagContext>): FeatureFlagContext {
        if (!model) return null;
        return FeatureFlagContext.newInstance(<FeatureFlagContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FeatureFlagContext) {
        if (!obj) return;

        models.FeatureFlagContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FeatureFlagContext): boolean {
        Object.setPrototypeOf(obj, FeatureFlagContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User id of the user to whom feature flag state is needed
     */
    user_id: string;

    /**
     * The context user's email id.
     */
    email: string;

    /**
     * Master account id to which flag state is needed.
     */
    master_account_id: string;

    /**
     * Tenant id to which flag state is needed.
     */
    tenant_id: string;

    /**
     * Role id to which flag state is needed.
     */
    role_id: string;

    /**
     * The group id to which flag state is needed
     */
    group_id: string;

    /**
     * Ip address to which feature flag state is needed
     */
    ip_address: string;

    /**
     * Country to which feature flag state is needed
     */
    country: string;

    /**
     * Region to which feature flag state is needed
     */
    region: string;

}
